import { render, staticRenderFns } from "./ButtonPrimary.vue?vue&type=template&id=34835d64&scoped=true&"
import script from "./ButtonPrimary.vue?vue&type=script&lang=js&"
export * from "./ButtonPrimary.vue?vue&type=script&lang=js&"
import style0 from "./ButtonPrimary.vue?vue&type=style&index=0&id=34835d64&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34835d64",
  null
  
)

export default component.exports